import { HiBell } from "react-icons/hi2";
import { Button } from "./button";
import { useEffect } from "react";

export function NotificationBell() {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes heartbeat {
        0%, 100% { transform: scale(1); }
        25%, 75% { transform: scale(1.2); }
      }

      @keyframes dotColorPulse {
        0%, 100% { background-color: #6b7280; } /* gray-500 */
        25%, 75% { background-color: #dc2626; } /* red-600 */
      }

      .heartbeat-icon {
        animation: heartbeat 1.5s infinite;
      }

      .heartbeat-dot {
        animation: dotColorPulse 1.5s infinite;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="heartbeat-icon items-end">
      <Button variant="ghost" size="icon" className="text-gray-900">
        <HiBell className="w-12 h-12" />
      </Button>
      <span className="heartbeat-dot absolute top-2 right-2 h-1.5 w-1.5 rounded-full bg-gray-500"></span>
    </div>
  );
}
